import { checkMark } from "@/designSystemIcons";
import { useTranslation } from "@repo/shared/i18n";
import { CopyIcon } from "lucide-react";
import { useState } from "react";

const checkMarkIcon = checkMark("white");

export const CopyLinkButton = () => {
  const { t } = useTranslation("clubImport");
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`
        h-9 px-4 py-1 rounded flex items-center justify-center gap-2
        transition-all duration-300 ease-in-out
        transform active:scale-95
        ${
          isCopied
            ? "bg-[#0d9488] hover:bg-[#0b8277]"
            : "bg-primary-action-default hover:bg-primary-action-hover"
        }
      `}
    >
      {/* Icon Container */}
      <div className="relative w-6 h-6 flex items-center justify-center shrink-0">
        {/* Checkmark Icon */}
        <div
          className={`
            absolute inset-0 flex items-center justify-center
            transition-all duration-300 ease-in-out
            ${
              isCopied
                ? "opacity-100 scale-100 rotate-0"
                : "opacity-0 scale-75 rotate-90 pointer-events-none"
            }
          `}
        >
          <div className="w-6 h-6 flex items-center justify-center text-white [&_svg]:w-6 [&_svg]:h-6">
            {checkMarkIcon}
          </div>
        </div>
        {/* Copy Icon */}
        <div
          className={`
            absolute inset-0 flex items-center justify-center
            transition-all duration-300 ease-in-out
            ${
              isCopied
                ? "opacity-0 scale-75 -rotate-90 pointer-events-none"
                : "opacity-100 scale-100 rotate-0"
            }
          `}
        >
          <div className="w-6 h-6 flex items-center justify-center text-white [&_svg]:w-6 [&_svg]:h-6">
            <CopyIcon />
          </div>
        </div>
      </div>

      {/* Text */}
      <span
        className={`
          text-white text-base font-medium whitespace-nowrap
          transition-opacity duration-300 ease-in-out
        `}
      >
        {isCopied ? t("mobile.copyLink.copied") : t("mobile.copyLink.copy")}
      </span>
    </button>
  );
};
